import React from 'react'
import { IdentificacaoPlano } from '../../../../interfaces/entities/ComponenteCadastral/IdentificacaoPlano'
import { useAccessibility } from '../../../../Store/contexts/AccessibilityContext';

const ComponenteCadastralPlanoData: React.FC<{ identificacaoPlano: IdentificacaoPlano | null }> = ({ identificacaoPlano }) => {

  const accessibility = useAccessibility();
  const font14Style = accessibility.calculateTextStyle(14)
  
  return (
    <div className="registration-data-card-holder margin-top">
      <div className="registration-data-card-service" style={{...accessibility.contrastBorderAccessibility, ...accessibility.contrastStyle }}>
        <div className="registration-data-row">
          <span style={accessibility.textStyleAccessibility} className="registration-data-title">Identificação do Plano</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary" style={{...accessibility.contrastBorderAccessibility, ...accessibility.contrastStyle }}>
          <span style={font14Style} className="registration-data-key">Número do contrato/Apólice</span>
          <span style={font14Style} className="registration-data-value">{identificacaoPlano?.numeroContratoApolice}</span>
        </div>
        <div className="registration-data-row ">
          <span style={font14Style} className="registration-data-key">Nome civil do(a) contratante</span>
          <span style={font14Style} className="registration-data-value">{identificacaoPlano?.nomeContratantePlanoColetivo}</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary" style={{...accessibility.contrastBorderAccessibility, ...accessibility.contrastStyle }}>
          <span style={font14Style} className="registration-data-key">Tipo de contratação</span>
          <span style={font14Style} className="registration-data-value">{identificacaoPlano?.tipoContratacao}</span>
        </div>
        <div className="registration-data-row ">
          <span style={font14Style} className="registration-data-key">Data da contratação do plano</span>
          <span style={font14Style} className="registration-data-value">{identificacaoPlano?.dtContratacaoPlanoSaude}</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary" style={{...accessibility.contrastBorderAccessibility, ...accessibility.contrastStyle }}>
          <span style={font14Style} className="registration-data-key">Segmentação assistencial</span>
          <span style={font14Style} className="registration-data-value">{identificacaoPlano?.segmentacaoAssistencial}</span>
        </div>
        <div className="registration-data-row">
          <span style={font14Style} className="registration-data-key">Registro do Plano na ANS</span>
          <span style={font14Style} className="registration-data-value">{identificacaoPlano?.registroPlanoANS}</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary" style={{...accessibility.contrastBorderAccessibility, ...accessibility.contrastStyle }}>
          <span style={font14Style} className="registration-data-key">Regulamentação</span>
          <span style={font14Style} className="registration-data-value">{identificacaoPlano?.regulamentacao}</span>
        </div>
        <div className="registration-data-row">
          <span style={font14Style} className="registration-data-key">Abrangência geográfica</span>
          <span style={font14Style} className="registration-data-value">{identificacaoPlano?.abrangencia}</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary" style={{...accessibility.contrastBorderAccessibility, ...accessibility.contrastStyle }}>
          <span style={font14Style} className="registration-data-key">Nome do produto</span>
          <span style={font14Style} className="registration-data-value">{identificacaoPlano?.nomeProduto}</span>
        </div>
        <div className="registration-data-row">
          <span style={font14Style} className="registration-data-key">Prazos de carências <br />
            <span style={font14Style}  className='registration-data-key-plano'>(mais detalhes no contrato)</span>
          </span>
          {identificacaoPlano?.prazosCarencia && (
            <span style={accessibility.textStyleAccessibility} className="registration-data-value" dangerouslySetInnerHTML={{ __html: identificacaoPlano?.prazosCarencia }} />
          )}
        </div>
      </div>
    </div>
  )
}

export default ComponenteCadastralPlanoData